/**
 * Calculate the isochrone step time from the index (zero based)
 * @param {number} index
 * @param {number} totalDur
 */
export function indexToMinutes(index, totalDur) {
   const stepLength = totalDur / reachMap.legend.colors.length;

   const value = Math.round((index + 1) * stepLength);

   return (value);
}
